import * as React from 'react';
import styles from './risk-result-overlay.module.css';
import Button from '../../../components/common/button/button';

import legendGreen from '../images/greenLegend.svg';
import legendBlue from '../images/blueLegend.svg';
import riskResult1 from '../images/risk-result-1.svg';
import riskResult2 from '../images/risk-result-2.svg';
import riskResult3 from '../images/risk-result-3.svg';
import riskResult4 from '../images/risk-result-4.svg';
import riskResult5 from '../images/risk-result-5.svg';
import riskResult6 from '../images/risk-result-6.svg';

import { ProgressBarComponent } from '@assetmark/common-elements/dist/progressBar/progressBar';
import { TInvestmentReturn } from '../../../models/investment-return.model';
import { useEffect } from 'react';
import { TRiskProfileResponse } from '../../../models/risk-profile.model';
import { fromNullable } from 'fp-ts/lib/Option';

export type TRiskToleranceProps = {
	profileId: number;
	riskProfiles: TRiskProfileResponse[];
	investmentAmount: number;
	model: TInvestmentReturn;
	onReview?: () => void;
	onRestart?: () => void;
};

export const RiskResultOverlay: React.FC<TRiskToleranceProps> = ({
	profileId,
	riskProfiles,
	investmentAmount,
	model,
	onReview,
	onRestart,
}) => {
	useEffect(() => {
		//console.log('Load Risk Result :>> ');
	}, []);

	const calculatedRiskProfile = riskProfiles.find(r => r.id === profileId);

	let assetAllocImg;
	let equity;
	let fixedIncome;
	switch (profileId) {
		case 1:
		  assetAllocImg = riskResult1;
		  equity = 20;
		  fixedIncome = 80;
		  break;
		case 2:
		  assetAllocImg = riskResult2;
		  equity = 35;
		  fixedIncome = 65;
		  break;
		case 3:
		  assetAllocImg = riskResult3;
		  equity = 60;
		  fixedIncome = 40;
		  break;
		case 4:
		  assetAllocImg = riskResult4;
		  equity = 75;
		  fixedIncome = 25;
		  break;
		case 5:
		  assetAllocImg = riskResult5;
		  equity = 85;
		  fixedIncome = 15;
		  break;
		case 6:
		  assetAllocImg = riskResult6;
		  equity = 100;
		  fixedIncome = 0;
		  break;
	  }
	
	if(profileId === 0) {
		return null;
	}

	return (
		<div className={styles.riskToleranceOverlay}>
			<div className={styles.overlayFlexBox}>
				<h3 className={styles.overlayTitle}>
					Your risk tolerance is <span className={styles.riskProfileName}>{calculatedRiskProfile ? calculatedRiskProfile.profileType : ''}</span>
				</h3>
			</div>
			<div className={styles.overlayContent}>
				<div className={`${styles.riskResultBox}`}>
					<h2 className={`${styles.riskBoxTitle}`}>Risk Profile Rating</h2>
					<div className={`${styles.profileRatingDescBox}`}>
						<div className={`${styles.profileRatingNo}`}>
							<span>{profileId}</span>
						</div>
						<div className={`${styles.profileRatingDesc}`}>
							<span>{calculatedRiskProfile ? calculatedRiskProfile.description : ''}</span>
						</div>
					</div>
				</div>
				<div className={`${styles.riskResultBox}`}>
					<h2 className={`${styles.riskBoxTitle}`}>Traditional Asset Allocation</h2>
					<div className={`${styles.chartContainer}`}>
						<div className={`${styles.chartImg}`}>
							<img src={assetAllocImg} alt="Risk Result Image" />
						</div>
						<div className={`${styles.legentContainer}`}>
							<div className={`${styles.chartLegent} pb-2.5`}>
								<img src={legendBlue} alt="Blue Legend" />
								<span className={'pl-2.5 text-sm'}>Equity - {equity}%</span>
							</div>
							<div className={`${styles.chartLegent}`}>
								<img src={legendGreen} alt="Green Legend" />
								<span className={'pl-2 text-sm'}>Fixed Income - {fixedIncome}%</span>
							</div>
						</div>
					</div>
				</div>
				<div className={`${styles.riskResultBox} ${styles.returnRange}`}>
					<h2 className={`${styles.riskBoxTitle}`}>Historical 12 Month Range of Returns</h2>
					<div className={`${styles.riskRangeBar}`}>
						<div className={`${styles.progressBar}`}>
							<ProgressBarComponent
								height={200}
								investmentAmount={investmentAmount}
								allSeries={[model]}
								seriesReturns={model}
								classTop={styles.top}
								classBottom={styles.bottom}
								classRect={styles.rect}
								classDataLabel={styles.datalabel}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className={`${styles.riskToeranceButton}`}>
				<Button
					name={'btnYourAnalysis'}
					className={`button button-lg ${styles.reviewBtn}`}
					text={'YOUR ANALYSIS'}
					disabled={false}
					onClick={onReview}
				/>
				<div>
					<a onClick={onRestart} className={`${styles.restartProfileLink}`}>
						Restart Risk Profile
					</a>
				</div>
			</div>
		</div>
	);
};
